import { render, staticRenderFns } from "./FixedRentalSettings.vue?vue&type=template&id=2b1b66c6&"
import script from "@/scripts/components/fixedRental/fixedRentalSettings.js?vue&type=script&lang=js&"
export * from "@/scripts/components/fixedRental/fixedRentalSettings.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports